exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".onboardingChecklistItem{margin-top:1rem;margin-bottom:1rem;cursor:pointer}.onboardingChecklistItem.complete{border-color:#42af14}.onboardingChecklistItem.incomplete{border-color:#ddd}.onboardingChecklistItem.next{border-color:#00a0f4}.onboardingChecklistItem .imageSection,.onboardingChecklistItem .infoSection{display:inline-block;vertical-align:middle}.onboardingChecklistItem .imageSection{width:15%;margin-right:1rem}.onboardingChecklistItem .itemImg{width:100%}.onboardingChecklistItem .infoSection{max-width:70%}.onboardingChecklistItem .completeText{color:#42af14;font-style:italic}.onboardingChecklistItem .verticalDivider{height:20px;border-color:#ddd;margin-left:5px;margin-right:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/teachers/onboarding_checklist_item.scss
// module id = 1444
// module chunks = 0